import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05d3dd16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-fotter" }
const _hoisted_2 = { class: "button-wrapper" }

import { onMounted, reactive } from "vue";
import CustomButton from "../generics/CustomButton.vue";
import { useBookingStore } from "@/store/bookingStore";
import { router } from "@/router/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationFooter',
  props: {},
  setup(__props) {



const bookingStore = useBookingStore();

function get_next_step() {
  if (bookingStore.currentBuyPath != undefined) {
    router.push(bookingStore.currentBuyPath.nextPath);
  }
}

function handle_back_click() {
  router.go(-1);
}

onMounted(() => {
  if (bookingStore.currentBuyPath?.path) {
    bookingStore.validate_step(bookingStore.currentBuyPath?.path);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (
            _unref(bookingStore).ticketBuyPaths.indexOf(_unref(bookingStore).currentBuyPath) > 0
          )
          ? (_openBlock(), _createBlock(CustomButton, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handle_back_click()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Tillbaka ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (_unref(bookingStore).currentBuyPath?.nextPath != '')
          ? (_openBlock(), _createBlock(CustomButton, {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (get_next_step())),
              disabled: !_unref(bookingStore).currentBuyPath?.valid
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Nästa ")
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})